import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { 
    Button, 
    Input, 
    Switch, 
    Typography, 
    message, 
    Upload, 
    Select, 
    Row, 
    Col,
    Modal,
    Table,
    Space
} from 'antd';
import { 
    ImportOutlined, 
    UserAddOutlined,
    DeleteOutlined
} from '@ant-design/icons';
import useGroupsStore from '../../stores/useGroupsStore';
import _ from 'lodash';
import apiCore from '../../utils/api-core';
import session from '../../utils/session';
import Papa from 'papaparse';
import AddContactsModal from './AddContactsModal';

const { Title, Text } = Typography;
const { Option } = Select;

const CreateGroupV2 = ({ history, location }) => {
    const {
        createGroup,
        fetchGroups,
        groups
    } = useGroupsStore();

    const presetTemplate = location?.state?.template;
    const initialName = presetTemplate
        ? `${presetTemplate.name} – ${new Date().toLocaleDateString()}`
        : '';

    // Group Details State
    const [groupName, setGroupName] = useState(initialName);
    const [isPrivacy, setIsPrivacy] = useState(false);

    // Loading State
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchGroups();
    }, []);

    const handleCreateGroup = async (action = null) => {
        if (!groupName.trim()) {
            message.error('Please enter a group name first');
            // Allow user to focus input, maybe highlight it? 
            document.getElementById('groupNameInput')?.focus();
            return;
        }

        setLoading(true);
        try {
            const res = await createGroup({
                name: groupName,
                privacy: isPrivacy ? 'private' : 'public',
                contactIds: [] // No staging anymore
            });
            
            const newGroup = res.data || res; 
            
            if (newGroup && newGroup.id) {
                // Redirect with state to open modal if action is provided
                history.replace({
                    pathname: `/groups/${newGroup.id}`,
                    state: { 
                        openImport: action === 'import',
                        openAddExisting: action === 'add-existing'
                    }
                });
            } else {
                 history.push('/groups');
            }

        } catch (error) {
            console.error(error);
            message.error('Failed to create group');
        } finally {
            setLoading(false);
        }
    };

    // Columns for Staged Table
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <Text strong>{text}</Text>
        },
        {
            title: 'Mobile',
            dataIndex: 'mobile',
            key: 'mobile',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },

    ];



    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', background: '#f0f2f5' }}>
            {/* Header */}
            <div style={{ 
                padding: '16px 12px', 
                background: '#fafafa', 
                borderBottom: '1px solid #e8e8e8',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <Title level={4} style={{ margin: 0 }}>Create New Group</Title>
                </div>
                <Space>
                    <Button onClick={() => history.push('/groups')}>Cancel</Button>
                    <Button type="primary" onClick={() => handleCreateGroup()} loading={loading}>Save Group</Button>
                </Space>
            </div>

            {/* Config Section */}
            
            <div style={{ background: '#fff', padding: 12}}>
                <Space direction="vertical" style={{ width: '100%' }}>
                    <div style={{ maxWidth: '50%' }}>
                        <Text strong>Group Name</Text>
                        <Input 
                            id="groupNameInput"
                            placeholder="Enter group name" 
                            value={groupName}
                            onChange={(e) => setGroupName(e.target.value)}
                        />
                    </div>
                    <div>
                        <Text strong>Privacy</Text>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                            <Switch 
                                checked={isPrivacy} 
                                onChange={setIsPrivacy} 
                                checkedChildren="Private" 
                                unCheckedChildren="Public" 
                            />
                            <Text type="secondary" style={{ marginLeft: 8 }}>
                                {isPrivacy ? 'Only visible to you' : 'Visible to everyone'}
                            </Text>
                        </div>
                    </div>
                </Space>
            </div>
            

            {/* Contacts Area */}
            <div style={{ flex: 1, margin: 0, backgroundColor: 'white', borderTop: '1px solid #E6E6E6', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                <div style={{ 
                    padding: '16px 24px', 
                    background: '#FAFAFA', 
                    borderBottom: '1px solid #E6E6E6',
                    display: 'flex', 
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <div>
                        <Text strong style={{ fontSize: 16 }}>Contacts</Text>
                        <Text type="secondary" style={{ marginLeft: 8 }}>
                            (0 total)
                        </Text>
                    </div>
                    <Space>
                        <Button 
                            icon={<UserAddOutlined />} 
                            onClick={() => handleCreateGroup('add-existing')}
                            loading={loading}
                        >
                            Add Existing
                        </Button>
                        <Button 
                            icon={<ImportOutlined />} 
                            onClick={() => handleCreateGroup('import')}
                            loading={loading}
                        >
                            Import
                        </Button>
                    </Space>
                </div>

                <div style={{ padding: '12px', flex: 1, overflowY: 'auto' }}>
                    <Table 
                        dataSource={[]} 
                        columns={columns} 
                        rowKey="id"
                        pagination={false}
                        size="small"
                        locale={{ emptyText: 'No contacts added yet. Use the buttons above to add contacts.' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default withRouter(CreateGroupV2);

